var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigiArsMenuIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "h2miia-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10254 5.44464C4.53893 5.44464 4.08203 5.90154 4.08203 6.46515V20.7523C4.08203 21.3159 4.53893 21.7728 5.10254 21.7728H19.3896C19.9533 21.7728 20.4102 21.3159 20.4102 20.7523V6.46515C20.4102 5.90154 19.9533 5.44464 19.3896 5.44464H5.10254ZM2.04102 6.46515C2.04102 4.77432 3.41171 3.40363 5.10254 3.40363H19.3896C21.0805 3.40363 22.4512 4.77432 22.4512 6.46515V20.7523C22.4512 22.4431 21.0805 23.8138 19.3896 23.8138H5.10254C3.41171 23.8138 2.04102 22.4431 2.04102 20.7523V6.46515Z",
    fill: "#707494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "h2miia-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3281 1.36261C16.8917 1.36261 17.3486 1.81951 17.3486 2.38312V6.46515C17.3486 7.02876 16.8917 7.48566 16.3281 7.48566C15.7645 7.48566 15.3076 7.02876 15.3076 6.46515V2.38312C15.3076 1.81951 15.7645 1.36261 16.3281 1.36261Z",
    fill: "#707494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "h2miia-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16406 1.36261C8.72767 1.36261 9.18457 1.81951 9.18457 2.38312V6.46515C9.18457 7.02876 8.72767 7.48566 8.16406 7.48566C7.60045 7.48566 7.14355 7.02876 7.14355 6.46515V2.38312C7.14355 1.81951 7.60045 1.36261 8.16406 1.36261Z",
    fill: "#707494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "h2miia-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04102 10.5472C2.04102 9.98357 2.49791 9.52667 3.06152 9.52667H21.4307C21.9943 9.52667 22.4512 9.98357 22.4512 10.5472C22.4512 11.1108 21.9943 11.5677 21.4307 11.5677H3.06152C2.49791 11.5677 2.04102 11.1108 2.04102 10.5472Z",
    fill: "#707494"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h2miia-stroke",
    d: "M7.85974 19.6552L11.226 15.3711L13.5722 17.0026L16.6324 13.7894",
    stroke: "#707494",
    strokeWidth: 1.67442,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiArsMenuIcon);
export default __webpack_public_path__ + "static/media/DigiArsMenuIcon.81689f4f0f8b20657f671d0d0d59dea3.svg";
export { ForwardRef as ReactComponent };